import {
  OrderItemCreateRequestType,
  OrderItemCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderItemCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderItemCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `order-items`,
        data,
      }).then(
        (data) => apiV2AssertResponse(data).data as OrderItemCreateResponseType,
      ),

    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderItems],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Orders,
          data.OrderId,
        ],
      });
    },
  });
};
